<template>
  <h6>
    <slot />
  </h6>
</template>

<script>
export default {
  props: {},
};
</script>

<style scoped>
h6 {
  margin-top: 0;
  margin-bottom: 0;

  color: var(--gray-800);

  font-size: 18px;
  font-family: var(--font-family-sans);
  font-weight: 500;
  line-height: 24px;
  text-align: left !important; /* NOTE @chris Global leak. */
}
</style>
